// extracted by mini-css-extract-plugin
export var closeButton = "_mm-1";
export var closeX = "_mm-3";
export var container = "_mm-0";
export var image = "_mm-2";